<template>
  <header class="header">
    <nav class="main-navigation">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="navbar-header">
                        <span class="nav-toggle-button collapsed" data-toggle="collapse" data-target="#main-menu">
                        <span class="sr-only">Toggle navigation</span>
                        <i class="fa fa-bars"></i>
                        </span>
                    </div>
                    <ul class="menu">
                      <li role="presentation"><a v-link="'/routes'">路线</a></li>
                      <li role="presentation"><a v-link="'/product/trip'">旅行</a></li>
                      <li role="presentation"><a v-link="'/arrange'">领队调度</a></li>
                      <li role="presentation"><a v-link="'/train/normal'">培训</a></li>
                      <li role="presentation"><a v-link="'/try/normal'">试走</a></li>
                      <li role="presentation"><a v-link="'/givers'" >领队管理</a></li>
                      <!-- <li role="presentation"><a v-link="'/adminer'" >管理员管理</a></li> -->
                      <li role="presentation"><a v-link="'/feedback'" >反馈</a></li>
                      <li class="pull-right" role="presentation"><a @click="auth()" href="javascript:void(0)">{{ isLogin ? '注销' : '登录' }}</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
  </header>
</template>
<script>
  import utils from '../libs/utils'
  import Cookie from 'js-cookie'
  export default {
    data () {
      return {
        isLogin: false
      }
    },
    methods: {
      auth () {
        if (this.isLogin) {
          // 注销
          Cookie.remove('_account', {
            domain: process.env.DOMAIN
          })
        }
        utils.login()
      }
    },
    ready () {
      this.isLogin = !!Cookie.get('_account')
    }
  }
</script>
<style scoped>
  a {
    text-decoration: none;
  }
  .main-navigation {
    text-align: center;
    background: #ffffff;
    border-top: 1px solid #ebebeb;
    margin-bottom: 35px;
    border-bottom: 2px solid #e1e1e1;
  }
  .main-navigation .menu {
    padding: 0;
    margin: 0;
  }
  .main-navigation .menu li {
    list-style: none;
    display: inline-block;
    position: relative;
  }
  .main-navigation .menu li.nav-current {
    border-bottom: 2px solid #e67e22;
    margin-bottom: -2px;
  }
  .main-navigation .menu li a {
    color: #505050;
    line-height: 4em;
    display: block;
    padding: 0 21px;
  }
  .main-navigation .menu li:hover > a {
    color: #e67e22;
    text-decoration: none;
  }
  .main-navigation .menu li ul {
    visibility: hidden;
    background: #ffffff;
    text-align: left;
    padding: 7px 0px;
    margin: 0;
    position: absolute;
    left: 0;
    top: 120%;
    width: 200px;
    z-index: 999;
    opacity: 0;
    filter: alpha(opacity=0);
    -webkit-transition: all 0.2s ease;
         -o-transition: all 0.2s ease;
            transition: all 0.2s ease;
  }
  .main-navigation .menu li ul li {
    display: block;
    margin: 0;
  }
  .main-navigation .menu li ul li a {
    line-height: 2.5em;
    color: #505050;
  }
  .main-navigation .menu li ul:hover > a {
    color: #e67e22;
  }
  .main-navigation .menu li:hover ul {
    visibility: visible;
    opacity: 1;
    filter: alpha(opacity=100);
    top: 100%;
  }
  /* navbar */
  .navbar-header {
    text-align: center;
  }
  .navbar-header i {
    height: 56px;
    line-height: 56px;
    font-size: 2em;
    cursor: pointer;
  }
  @media (min-width: 768px) {
    .nav-toggle-button {
      display: none;
    }
  }
  .v-link-active {
    border-bottom: 2px solid #e67e22;
    margin-bottom: -2px;
  }
</style>



/** WEBPACK FOOTER **
 ** Header.vue?1ed7cd19
 **/